/**
 * List of all the available Number™ specific icons for easier use in SBIcon component.
 */
export default {
  ACTION_IMPORT: {
    fileName: 'action-import.svg',
  },
  ACTION_EXPORT: {
    fileName: 'action-export.svg',
  },
  ACTION_BROADCAST: {
    fileName: 'action-broadcast.svg',
  },
  ADD_TAG: {
    fileName: 'add-tag.svg',
  },
  ANALYTICS_THREE_BAR: {
    fileName: 'analytics_three_bar.svg',
  },
  APP_DOWNLOAD_DESKTOP: {
    fileName: 'app-download.svg',
  },
  ARROW: {
    fileName: 'arrow.svg',
  },
  ARROW_45: {
    fileName: 'arrow-45.svg',
  },
  ARROW_BIDIRECTION: {
    fileName: 'bidirection-arrow.svg',
  },
  ARROW_DOTS: {
    fileName: 'arrow-dots.svg',
  },
  ARROW_DOWN: {
    fileName: 'arrow-down.svg',
  },
  ARROW_THICK: {
    fileName: 'arrow-thick.svg',
  },
  ARROW_CIRCLE: {
    fileName: 'arrow-circle.svg',
  },
  ARROW_LONG: {
    fileName: 'arrow-long.svg',
  },
  ARROW_ROUNDED: {
    fileName: 'arrow-rounded.svg',
  },
  ARROW_THIN_TIP_RIGHT: {
    fileName: 'arrow-tin-tip-right.svg',
  },
  ATTACH: {
    fileName: 'attach.svg',
  },
  AUTOMATED: {
    fileName: 'automated.svg',
  },
  BADGE: {
    fileName: 'badge.svg',
  },
  BLOCK: {
    fileName: 'block.svg',
  },
  BLOCK_THICK: {
    fileName: 'block_thick.svg',
  },
  BLOCKED: {
    fileName: 'blocked.svg',
  },
  BLOCKED_CONTACTS: {
    fileName: 'blocked-contacts.svg',
  },
  BOT_ON: {
    fileName: 'bot-on.svg',
  },
  BOT_OFF: {
    fileName: 'bot-off.svg',
  },
  BROADCAST: {
    fileName: 'broadcast.svg',
  },
  BROWSER: {
    fileName: 'browser.svg',
  },
  BUSINESS: {
    fileName: 'user-business-dark.svg',
  },
  CALENDAR: {
    fileName: 'calendar.svg',
  },
  CF_BOOLEAN: {
    fileName: 'cf-boolean.svg',
  },
  CF_NUMBER: {
    fileName: 'cf-number.svg',
  },
  CF_TEXT: {
    fileName: 'cf-text.svg',
  },
  CF_LIST: {
    fileName: 'cf-list.svg',
  },
  CF_EMAIL: {
    fileName: 'cf-email.svg',
  },
  CF_DATE: {
    fileName: 'cf-date.svg',
  },
  CLOCK: {
    fileName: 'clock.svg',
  },
  CLOSE_THIN: {
    fileName: 'close-thin.svg',
  },
  CLOSE_THICK: {
    fileName: 'close-thick.svg',
  },
  COG: {
    fileName: 'cog.svg',
  },
  CONTACT_FIELD: {
    fileName: 'contact-field.svg',
  },
  CONVERSATION_READ: {
    fileName: 'conversation-read.svg',
  },
  CONVERSATION_UNREAD: {
    fileName: 'conversation-unread.svg',
  },
  COPY: {
    fileName: 'copy-light.svg',
  },
  COPY_TALL: {
    fileName: 'copy.svg',
  },
  CREDIT_CARD: {
    fileName: 'credit-card.svg',
  },
  CROSS_CIRCLE: {
    fileName: 'cross-circle.svg',
  },
  DOC: {
    fileName: 'doc.svg',
  },
  DOC_DARK: {
    fileName: 'doc-dark.svg',
  },
  DOC_NEW: {
    fileName: 'doc-new.svg',
  },
  DONE_CIRCLE: {
    fileName: 'done-circle.svg',
  },
  DONE_CIRCLE_HOLLOW: {
    fileName: 'done-circle-hollow.svg',
  },
  DONE_TICK: {
    fileName: 'done-tick-blue.svg',
  },
  DONE_TICK_THIN: {
    fileName: 'done-tick.svg',
  },
  DOWN_ARROW: {
    fileName: 'down-arrow.svg',
  },
  DOWNLOAD: {
    fileName: 'download-arrow.svg',
  },
  DOWNLOAD_SQUARE: {
    fileName: 'download-square.svg',
  },
  DRAG: {
    fileName: 'drag.svg',
  },
  EMOJI: {
    fileName: 'emoji-icon.svg',
  },
  EMOJI_COLOR: {
    fileName: 'emoji-icon-color.svg',
  },
  ENTER: {
    fileName: 'enter.svg',
  },
  ERROR: {
    fileName: 'error.svg',
  },
  EXPORT: {
    fileName: 'export.svg',
  },
  EYE_CLOSED: {
    fileName: 'eye-closed.svg',
  },
  EYE_OPEN: {
    fileName: 'eye-open.svg',
  },
  FILTER: {
    fileName: 'filter.svg',
  },
  FILTER_LINES: {
    fileName: 'filter-lines.svg',
  },
  FLASH: {
    fileName: 'flash.svg',
  },
  FORMAT_B: {
    fileName: 'format-b.svg',
  },
  FORMAT_I: {
    fileName: 'format-i.svg',
  },
  FORMAT_S: {
    fileName: 'format-s.svg',
  },
  FULL_ARROW_RIGHT: {
    fileName: 'full-arrow-right.svg',
  },
  GLOBE: {
    fileName: 'globe.svg',
  },
  GREEN_TICK: {
    fileName: 'green-tick.svg',
  },
  HEADPHONES: {
    fileName: 'headphones.svg',
  },
  HYPERLINK: {
    fileName: 'hyperlink.svg',
  },
  IMAGE: {
    fileName: 'image.svg',
  },
  IMAGE_PLACEHOLDER: {
    fileName: 'image-placeholder.svg',
  },
  IMAGE_PLACEHOLDER_2: {
    fileName: 'image-placeholder-2.svg',
  },
  IMPORT: {
    fileName: 'import.svg',
  },
  INFO: {
    fileName: 'info.svg',
  },
  INFO_INVERSE: {
    fileName: 'info-inverse.svg',
  },
  INFORMATION: {
    fileName: 'information.svg',
  },
  KEY: {
    fileName: 'key.svg',
  },
  LIGHTBOX_CLOSE: {
    fileName: 'light-box-close.svg',
  },
  LIGHTBOX_DOWNLOAD: {
    fileName: 'light-box-download.svg',
  },
  LIST: {
    fileName: 'list.svg',
  },
  LOAD_MORE: {
    fileName: 'load-more.svg',
  },
  LOCK_CLOSED: {
    fileName: 'lock-closed.svg',
  },
  LOCK_OPEN: {
    fileName: 'lock-open.svg',
  },
  LOGS: {
    fileName: 'logs.svg',
  },
  MAGNIFIER: {
    fileName: 'magnifier.svg',
  },
  MESSAGE_BALLOON: {
    fileName: 'message-balloon.svg',
  },
  MESSAGE_FAILED: {
    fileName: 'message-failed.svg',
  },
  MESSAGE_SENT: {
    fileName: 'message-sent.svg',
  },
  MESSAGE_TEMPLATES_LOGO: {
    fileName: 'message-templates-logo.svg',
  },
  MESSAGE_TICK: {
    fileName: 'message-tick.svg',
  },
  MICROPHONE: {
    fileName: 'microphone.svg',
  },
  MICROPHONE_ACTIVE: {
    fileName: 'microphone-active.svg',
  },
  MINUS: {
    fileName: 'minus.svg',
  },
  NEW_MESSAGE: {
    fileName: 'new_message.svg',
  },
  NO_WHATSAPP: {
    fileName: 'no-whatsapp.svg',
  },
  NOTIFICATION_BELL: {
    fileName: 'notification-bell.svg',
  },
  PANEL_ANALYTICS: {
    fileName: 'panel-analytics.svg',
  },
  PANEL_CONTACTS: {
    fileName: 'panel-contacts.svg',
  },
  PANEL_CONVERSATIONS: {
    fileName: 'panel-conversations.svg',
  },
  PANEL_ME: {
    fileName: 'panel-me.svg',
  },
  PANEL_PHONE: {
    fileName: 'panel-phone.svg',
  },
  PANEL_SETTINGS: {
    fileName: 'panel-settings.svg',
  },
  SETTINGS_LIGHT: {
    fileName: 'settings-light.svg',
  },
  PAUSE: {
    fileName: 'pause.svg',
  },
  PAUSE_THIN: {
    fileName: 'pause-thin.svg',
  },
  PDF: {
    fileName: 'pdf.svg',
  },
  PENCIL: {
    fileName: 'pencil.svg',
  },
  PHONE: {
    fileName: 'phone.svg',
  },
  PHONE_OUTLINE: {
    fileName: 'phone-outline.svg',
  },
  PLAY: {
    fileName: 'play.svg',
  },
  PLAY_EMPTY: {
    fileName: 'play-empty.svg',
  },
  PLUS: {
    fileName: 'plus.svg',
  },
  PLUS_THIN: {
    fileName: 'plus-thin.svg',
  },
  PPT: {
    fileName: 'ppt.svg',
  },
  PROFILE_CIRCLE: {
    fileName: 'profile-circle.svg',
  },
  PROFILE_FILLED_CIRCLE: {
    fileName: 'profile-filled-circle.svg',
  },
  PROFILE_SHIELD: {
    fileName: 'profile-shield.svg',
  },
  QUESTION_CIRCLE: {
    fileName: 'question-circle.svg',
  },
  QUESTIONMARK: {
    fileName: 'questionmark.svg',
  },
  QUICKREPLY: {
    fileName: 'quickreply.svg',
  },
  QUICKREPLY_COLOR: {
    fileName: 'quickreply-color.svg',
  },
  QUICKREPLY_LOGO: {
    fileName: 'quick-reply.svg',
  },
  REFRESH: {
    fileName: 'refresh.svg',
  },
  REFRESH_CLOCKWISE: {
    fileName: 'refresh-clockwise.svg',
  },
  REFRESH_DOUBLE: {
    fileName: 'refresh-double.svg',
  },
  REFRESH_THICK: {
    fileName: 'refresh-thick.svg',
  },
  REPLY: {
    fileName: 'reply.svg',
  },
  REPLY_SINGLE: {
    fileName: 'reply-single.svg',
  },
  RETURN: {
    fileName: 'return.svg',
  },
  SEND: {
    fileName: 'send.svg',
  },
  SORT_ARROWS: {
    fileName: 'sort-arrows.svg',
  },
  TABLE: {
    fileName: 'table-icon.svg',
  },
  TAG: {
    fileName: 'tag.svg',
  },
  TAGS: {
    fileName: 'tags.svg',
  },
  THREE_DOTS: {
    fileName: 'menu-3-dots-light.svg',
  },
  TRASH: {
    fileName: 'trash.svg',
  },
  TRIANGLE_EXCLAMATION: {
    fileName: 'triangle-exclamation.svg',
  },
  TT: {
    fileName: 'Tt.svg',
  },
  USER_SQUARE: {
    fileName: 'user-square.svg',
  },
  VIDEO_PLACEHOLDER: {
    fileName: 'video-placeholder.svg',
  },
  XLS: {
    fileName: 'xls.svg',
  },
  WEBHOOK: {
    fileName: 'webhook.svg',
  },
  WHATSAPP_LOGO: {
    fileName: 'whatsapp-logo.svg',
  },
  WHATSAPP_LOGO_COLOR: {
    fileName: 'whatsapp-logo-color.svg',
  },
  WHATSAPP_LOGO_COLOR_2: {
    fileName: 'wa-color-logo.svg',
  },
  WHATSAPP_LOGO_THIN: {
    fileName: 'whatsapp-logo-thin.svg',
  },
  WHATSAPP_LOGO_THICK: {
    fileName: 'whatsapp-logo-thick.svg',
  },
  WHATSAPP_DELIVERED_TICK: {
    fileName: 'wa-delivered-tick.svg',
  },
  WHATSAPP_READ_TICK: {
    fileName: 'wa-read-tick.svg',
  },
  WORKING_HOURS: {
    fileName: 'working-hours.svg',
  },
  WORKING_HOURS_LOGO: {
    fileName: 'working-hours-logo.svg',
  },
};
